// Modules
import React from 'react';
import { inject, observer } from 'mobx-react';

import './style.css';

@inject('PinStore')
@observer
export default class extends React.Component {
  componentDidMount() {
    // Map Initializer
    const options = {
      zoom: 8,
      center: {
        lat: 35.367508,
        lng: -119.111036,
      },
    };

    this.props.PinStore.getPins();

    const map = new window.google.maps.Map(document.getElementById('map'), options);
    console.log(map);

    this.createInterval(map);
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalId);
    this.props.PinStore.unsubscribe();
  }

  createInterval = (map) => {
    const { pinList } = this.props.PinStore;
    this.addedPins = [];
    const intervalId = setInterval(() => {
      for (let i = 0; i < pinList.length; i += 1) {
        if (!this.addedPins.includes(pinList[i].locationId)) {
          this.addedPins.push(pinList[i].locationId);
          const marker = new window.google.maps.Marker({
            position: {
              lat: pinList[i].lat,
              lng: pinList[i].lng,
            },
            map,
            title: pinList[i].name,
          });
          console.log(marker);
        }
      }
    }, 300);

    this.setState({ intervalId });
  }

  render() {
    return (
      <div id="map" className="map-container" />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MapContainer/index.js